// @flow
import { combine, forward, guard } from 'effector'
import uuid from 'uuid/v4'
import { Storage } from 'utils/storage'
import { SESSION_ID_STORAGE_KEY } from 'services/session/constants'
import { UserService } from 'services/user'
import { notifications } from 'utils/notifications'
import AUTH_ROUTES from 'modules/auth/routes-map'
import { getSocialNetTitle } from '../utils'
import { domain } from './domain'
import {
  signUpFx,
  autoSignUpFx,
  logOutFx,
  deleteAccountFx,
  initializeSession,
  unlinkSocialFx,
  unlinkSocial,
} from './events'

const $sessionId = domain.createStore<string | null>(Storage.getItem(SESSION_ID_STORAGE_KEY) || null)
const $userServiceStore = UserService.getStore()

const $isSessionLoaded = $userServiceStore.map(({ isLoaded }) => isLoaded)

$sessionId
  .on(UserService.reset, () => null)
  .on(logOutFx.done, () => null)
  .on(deleteAccountFx.done, () => null)
  .on(signUpFx.done, () => uuid())
  .on(autoSignUpFx.done, () => uuid())
  .on(initializeSession, () => uuid())

$sessionId.updates.watch((sessionId) => {
  if (sessionId === null) {
    Storage.removeItem(SESSION_ID_STORAGE_KEY)
  } else {
    Storage.setItem(SESSION_ID_STORAGE_KEY, sessionId)
  }
})

// Initialize user store
forward({
  from: initializeSession,
  to: UserService.initialize,
})

forward({
  from: logOutFx.done,
  to: UserService.reset.prepend(() => undefined),
})

guard({
  source: unlinkSocial,
  filter: unlinkSocialFx.pending.map((pending) => !pending),
  target: unlinkSocialFx,
})

// Update user profile after successful unlinking
forward({
  from: unlinkSocialFx.done,
  to: UserService.getUser.prepend(() => 'profile'),
})

logOutFx.done.watch(() => {
  if (window === undefined) return

  if (process.env.REACT_APP_EXTERNAL === 'true') {
    window?.location.reload()

    return
  }

  window.location.href = `${AUTH_ROUTES.LOGIN}?redirect=${window.location.pathname}`
})

logOutFx.fail.watch(() => {
  notifications.error(`Не удалось выйти из учётной записи`)
})

unlinkSocialFx.done.watch(({ params: provider }) => {
  notifications.success(`Привязка к ${getSocialNetTitle(provider)} успешно удалена!`)
})

unlinkSocialFx.fail.watch(({ params: provider }) => {
  notifications.error(`Не удалось удалить привязку к ${getSocialNetTitle(provider)}`)
})

deleteAccountFx.fail.watch(() => notifications.error('Не удалось удалить учётную запись'))

const data = combine({
  isSessionLoaded: $isSessionLoaded,
  sessionId: $sessionId,
  isLoggedIn: $userServiceStore.map(({ isLoggedIn }) => isLoggedIn),
})

export { data }
